/* Manchester · 2026-05-20 — PDP "Beneficios" accordion fix (re-abrir + overlap).

   Bug: el accordion de Beneficios (y todos los .cc-accordion del theme) se
   abría una vez y luego NO se podía volver a abrir, y el panel se sobreponía
   con la descripción.

   Causa raíz (verificada en vivo): la JS nativa de Symmetry (AccordionInstance
   en theme.js) anima cerrando vía panel.style.height (scrollHeight → 0) y
   depende de que dispare `transitionend` para limpiar la clase `is-closing` y
   poner item.open = false. Pero el estado abierto en reposo es `height:auto`
   (custom.css.liquid: `.cc-accordion-item[open]:not(.is-closing) .__panel{height:auto}`)
   y `auto` NO es animable: al cerrar, el navegador va de auto→0 instantáneo,
   nunca anima, nunca dispara `transitionend`, así que `is-closing` queda pegada
   e item.open jamás vuelve a false → clicks posteriores no reabren y el panel
   abierto se encima del contenido siguiente.

   Fix: dejar que el <details> nativo maneje el toggle. Interceptamos el click
   sobre el <summary> en fase de captura (antes del listener delegado de Symmetry
   en el contenedor .cc-accordion) y detenemos su propagación. NO hacemos
   preventDefault, así que el toggle nativo del <details> (atributo [open]) ocurre
   normal. El CSS existente (`[open] .__panel{height:auto}` / si no `height:0`)
   muestra/oculta correctamente, y como `is-closing` nunca se agrega, el estado
   nunca se traba. Funciona en todos los .cc-accordion (todos sufrían el mismo bug).
*/
(function () {
  'use strict';

  function neutralize(root) {
    if (!root || root.dataset.mfgAccFixed) return;
    root.dataset.mfgAccFixed = '1';
    // Captura: corre antes del handler delegado (bubble) de Symmetry en el mismo nodo.
    root.addEventListener('click', function (evt) {
      var summary = evt.target.closest('summary, .cc-accordion-item__title');
      if (summary && root.contains(summary)) {
        evt.stopImmediatePropagation(); // bloquea handleClick de Symmetry; NO preventDefault
      }
    }, true);
    // Defensivo: limpiar cualquier estado pegado de una sesión previa.
    root.querySelectorAll('.cc-accordion-item.is-closing').forEach(function (it) {
      it.classList.remove('is-closing');
    });
  }

  function sweep() {
    document.querySelectorAll('.cc-accordion').forEach(neutralize);
  }

  function init() {
    sweep();
    // Cubrir accordions inyectados después (quickview, secciones lazy, etc.)
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains('cc-accordion')) neutralize(n);
          if (n.querySelectorAll) n.querySelectorAll('.cc-accordion').forEach(neutralize);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
